import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "page_header" }
const _hoisted_2 = { class: "formContainer" }
const _hoisted_3 = {
  filter: "name",
  sort: "name"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { colspan: "10" }
const _hoisted_7 = { class: "text-uppercase" }
const _hoisted_8 = { class: "text-uppercase" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_op_table = _resolveComponent("op-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_localized_text, {
        type: 'h1',
        localizedKey: "Garment Configuration",
        text: "Garment Configuration",
        class: "mb-0"
      }),
      _createElementVNode("button", {
        class: "btn btn-primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editGarment('0')))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "Add Garment",
          text: "Add Garment"
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_op_table, {
        class: "table table-striped",
        items: _ctx.items
      }, {
        default: _withCtx((opData) => [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_3, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Name",
                  text: "Name"
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Configuration",
                  text: "Configuration"
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Available sizes",
                  text: "Available sizes"
                })
              ]),
              _hoisted_4
            ])
          ]),
          _createElementVNode("tbody", null, [
            (opData.data.length == 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [
                  _createElementVNode("td", _hoisted_6, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "No Elements Found",
                      text: "No Elements Found"
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((opData.data as OM.TextIdentifier[]), (item, i) => {
              return (_openBlock(), _createElementBlock("tr", { key: i }, [
                _createElementVNode("td", _hoisted_7, _toDisplayString(item.text), 1),
                _createElementVNode("td", null, [
                  (_ctx.standaloneConfiguration(item.identifier))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" De Cecco - "),
                        _createVNode(_component_localized_text, {
                          localizedKey: "copy of",
                          text: "copy of"
                        }),
                        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.parentGarmentName(_ctx.standaloneConfiguration(item.identifier))), 1)
                      ], 64))
                    : (_openBlock(), _createBlock(_component_localized_text, {
                        key: 1,
                        localizedKey: "Standard",
                        text: "Standard"
                      }))
                ]),
                _createElementVNode("td", null, _toDisplayString(_ctx.standaloneConfiguration(item.identifier)?.sqmForSizes.length || '-'), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    onClick: ($event: any) => (_ctx.editGarment(item.identifier))
                  }, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Edit",
                      text: "Edit"
                    })
                  ], 8, _hoisted_9),
                  _createElementVNode("button", {
                    class: "btn btn-primary ms-1",
                    onClick: ($event: any) => (_ctx.defaultData(item.identifier))
                  }, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Default data",
                      text: "Default data"
                    })
                  ], 8, _hoisted_10)
                ])
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["items"])
    ])
  ], 64))
}